import { render, staticRenderFns } from "./CampaignTermsFields.vue?vue&type=template&id=8d3b5fd4&scoped=true"
import script from "./CampaignTermsFields.vue?vue&type=script&lang=js"
export * from "./CampaignTermsFields.vue?vue&type=script&lang=js"
import style0 from "./CampaignTermsFields.vue?vue&type=style&index=0&id=8d3b5fd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d3b5fd4",
  null
  
)

export default component.exports